import { Fragment, useEffect, useState } from "react";
import style from "./AgentForm.module.css";
import { Form, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import getProvince from "../functions/getProvinces";
import getCities from "../functions/getCities";
import Select from "react-select";
import getAreas from "../functions/getAreas";
import formAgentYupResolver from "../functions/formAgentYupResolver";
import AgentFormModal from "./AgentFormModal";
import doSubmit from "../functions/agentFormDoSubmit";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker from "react-multi-date-picker";

function AgentForm({ personType }) {
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [areas, setAreas] = useState([]);
  const [showModalCode, setShowModalCode] = useState(false);
  const [isloading, setIsLoading] = useState(false);

  const schema = formAgentYupResolver(personType, areas);

  const {
    handleSubmit,
    register,
    unregister,
    setValue,
    getValues,
    clearErrors,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    setValue("registrNumber", undefined);
    unregister("registrNumber");

    setValue("managerName", undefined);
    unregister("managerName");

    setValue("managerFamily", undefined);
    unregister("managerFamily");

    setValue("managerNationalCode", undefined);
    unregister("managerNationalCode");

    setValue("family", undefined);
    unregister("family");

    setValue("name", undefined);
    setValue("nationalCode", undefined);

    setValue("type", personType);

    clearErrors("nationalCode");
  }, [personType]);

  useEffect(() => {
    getProvince(setProvinces);
    register("type", { value: personType });
  }, []);

  return (
    <Fragment>
      <form
        onSubmit={handleSubmit(data =>
          doSubmit(
            data,
            () => setShowModalCode(() => true),
            res => setIsLoading(() => res)
          )
        )}
      >
        <div className={style.box}>
          {personType === 0 ? (
            <Fragment>
              <div className="mb-1">
                <Form.Label>
                  نام<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control type="text" {...register("name")} />
                {errors.name && <p>{errors.name?.message}</p>}
              </div>
              <div className="mb-1">
                <Form.Label>
                  نام خانوادگی<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control type="text" {...register("family")} />
                {errors.family && <p>{errors.family?.message}</p>}
              </div>
              <div className="mb-1">
                <Form.Label>
                  کد ملی<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control type="number" {...register("nationalCode")} />
                {errors.nationalCode && <p>{errors.nationalCode?.message}</p>}
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <div className="mb-1">
                <Form.Label>
                  نام شرکت<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control type="text" {...register("name")} />
                {errors.name && <p>{errors.name?.message}</p>}
              </div>
              <div className="mb-1">
                <Form.Label>
                  شماره ثبت شرکت
                  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control type="text" {...register("registrNumber")} />
                {errors.registrNumber && <p>{errors.registrNumber?.message}</p>}
              </div>
              <div className="mb-1">
                <Form.Label>
                  شناسه ملی شرکت
                  <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control type="text" {...register("nationalCode")} />
                {errors.nationalCode && <p>{errors.nationalCode?.message}</p>}
              </div>

              <div className="mb-1">
                <Form.Label>
                  نام مدیر عامل<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control type="text" {...register("managerName")} />
                {errors.managerName && <p>{errors.managerName?.message}</p>}
              </div>

              <div className="mb-1">
                <Form.Label>
                  نام خانوادگی مدیر عامل<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control type="text" {...register("managerFamily")} />
                {errors.managerFamily && <p>{errors.managerFamily?.message}</p>}
              </div>

              <div className="mb-1">
                <Form.Label>
                  کد ملی مدیر عامل<span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  {...register("managerNationalCode")}
                />
                {errors.managerNationalCode && (
                  <p>{errors.managerNationalCode?.message}</p>
                )}
              </div>
            </Fragment>
          )}

          <div className="mb-1">
            <Form.Label>
              شماره موبایل<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control type="number" {...register("phone")} />
            {errors.phone && <p>{errors.phone?.message}</p>}
          </div>
          <div className="mb-1">
            <Form.Label>ایمیل</Form.Label>
            <Form.Control type="text" {...register("email")} />
            {errors.email && <p>{errors.email?.message}</p>}
          </div>

          <div className="mb-1">
            <Form.Label>
              <span>
                <span>تاریخ تولد</span>
                {personType === 1 && <span> مدیر عامل</span>}
              </span>
              <span className="text-danger">*</span>
            </Form.Label>
            <Controller
              name="birthDay"
              control={control}
              render={({ field: { onChange, value } }) => (
                <DatePicker
                  calendar={persian}
                  locale={persian_fa}
                  value={value}
                  style={{ width: "100%" }}
                  onChange={e => {
                    if (e === null) {
                      onChange(undefined);
                      return;
                    }
                    onChange(e.year + "/" + e.month.number + "/" + e.day);
                  }}
                />
              )}
            />
            {errors.birthDay && <p>{errors.birthDay?.message}</p>}
          </div>

          <div className="mb-1">
            <Form.Label>
              رمز
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="password"
              autoComplete="new-password"
              {...register("password")}
            />
            {errors.password && <p>{errors.password?.message}</p>}
            {errors.confirmPassword?.type !== "required" && (
              <p>{errors.confirmPassword?.message}</p>
            )}
          </div>
          <div className="mb-1">
            <Form.Label>
              تکرار رمز
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="password"
              autoComplete="new-password"
              {...register("confirmPassword")}
            />
            {errors.confirmPassword && <p>{errors.confirmPassword?.message}</p>}
          </div>

          <div className="mb-1">
            <Form.Label>جنسیت</Form.Label>
            <Form.Select {...register("gender")}>
              <option value="مرد">مرد</option>
              <option value="زن">زن</option>
            </Form.Select>
          </div>

          <div className="mb-1">
            <Form.Label>تحصیلات</Form.Label>
            <Form.Select {...register("degree")}>
              <option value="دیپلم">دیپلم</option>
              <option value="فوق دیپلم">فوق دیپلم</option>
              <option value="لیسانس">لیسانس</option>
              <option value="فوق لیسانس">فوق لیسانس</option>
              <option value="دکتری و بالاتر">دکتری و بالاتر</option>
            </Form.Select>
          </div>

          <div className="mb-1">
            <Form.Label>
              استان
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
              {...register("province", {
                onChange: e => {
                  getCities(parseInt(e.target.value), setCities);
                  setAreas(() => []);
                  setValue("city", 0);
                  setValue("area", 0);
                },
              })}
            >
              <option value={0}>انتخاب کنید ...</option>
              {provinces.map(item => (
                <option key={item.id} value={item.id}>
                  {item.faName}
                </option>
              ))}
            </Form.Select>
            {errors.province && <p>{errors.province?.message}</p>}
          </div>

          <div className="mb-1">
            <Form.Label>
              شهر
              <span className="text-danger">*</span>
            </Form.Label>

            <Controller
              control={control}
              defaultValue={0}
              name="city"
              render={({ field: { onChange, value, ref } }) => (
                <Select
                  inputRef={ref}
                  classNamePrefix="dir-farsi "
                  options={cities}
                  value={cities.find(c => c.value === value)}
                  onChange={val => {
                    onChange(val.value);
                    setValue("area", 0);
                    setAreas(() => []);
                    getAreas(val.value, setAreas);
                  }}
                />
              )}
            />
            {errors.city && <p>{errors.city?.message}</p>}
          </div>

          <div className="mb-1">
            <Form.Label>
              منطقه
              {areas.length > 0 && <span className="text-danger">*</span>}
            </Form.Label>
            <Form.Select {...register("area")}>
              <option value={0}>انتخاب کنید ...</option>
              {areas.map(item => (
                <option value={item.id} key={item.id}>
                  {item.faName}
                </option>
              ))}
            </Form.Select>
            {errors.area && <p>{errors.area?.message}</p>}
          </div>

          <div className={"mb-1 " + style.textArea}>
            <Form.Label>
              آدرس
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control as="textarea" {...register("address")} />
            {errors.address && <p>{errors.address?.message}</p>}
          </div>

          <div className="mb-1">
            <Form.Label>
              رشته تحصیلی
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control type="text" {...register("major")} />
            {errors.major && <p>{errors.major?.message}</p>}
          </div>

          <div className="mb-1">
            <Form.Label>
              کد پستی
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control type="number" {...register("postCode")} />
            {errors.postCode && <p>{errors.postCode?.message}</p>}
          </div>

          <div className="mb-1">
            <Form.Label>
              تلفن
              <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control type="number" {...register("tel")} />
            {errors.tel && <p>{errors.tel?.message}</p>}
          </div>

          <div className="mb-1">
            <Form.Label>وضعیت نظام وظیفه</Form.Label>
            <Form.Select {...register("military")}>
              <option value="دارای کارت پایان خدمت">
                دارای کارت پایان خدمت
              </option>
              <option value="مشمول">مشمول</option>
              <option value="معاف">معاف</option>
              <option value="بانو هستم">بانو هستم</option>
            </Form.Select>
          </div>

          <div className="mb-1">
            <Form.Label>وضعیت تاهل</Form.Label>
            <Form.Select {...register("married")}>
              <option value="مجرد">مجرد</option>
              <option value="متاهل">متاهل</option>
            </Form.Select>
          </div>
          <div className="mb-1">
            <Form.Label>سن</Form.Label>
            <Form.Select {...register("age")}>
              <option value="کمتر از 25 سال ">کمتر از 25 سال </option>
              <option value="بین 25 تا 30 سال">بین 25 تا 30 سال</option>
              <option value="بین 30 تا 45 سال">بین 30 تا 45 سال</option>
              <option value="بالای 45 سال">بالای 45 سال</option>
            </Form.Select>
          </div>
          <div className="mb-1">
            <Form.Label>دسترسی به فضای دفتر کاری</Form.Label>
            <Form.Select {...register("havingOffice")}>
              <option value="بله">بله </option>
              <option value="خیر">خیر</option>
            </Form.Select>
          </div>
          <div className="mb-1">
            <Form.Label>نحوه آشنایی</Form.Label>
            <Form.Select {...register("acquaintance")}>
              <option value="سایت آواکس">سایت آواکس</option>
              <option value="دیوار">دیوار</option>
              <option value="دوستان">دوستان</option>
              <option value="نماینده یاب">نماینده یاب</option>
              <option value="شبکه های اجتماعی">شبکه های اجتماعی</option>
              <option value="سایت های خبری">سایت های خبری</option>
              <option value="سایر">سایر</option>
            </Form.Select>
          </div>
          <div className={"mb-1 " + style.textArea}>
            <Form.Label>
              آیا توان پرداخت مبلغ 25 میلیون تومان به‌عنوان وجه الضمان مفاصا
              حساب (دارایی،شهرداری،تامین اجتماعی) که نزد شرکت بصورت امانت تا
              پایان قرارداد می‌ماند، را در بدو عقد قرارداد دارید؟
            </Form.Label>
            <Form.Select
              {...register("canPayWarranty", { valueAsNumber: true })}
            >
              <option value={1}>بله</option>
              <option value={0}>خیر</option>
            </Form.Select>
          </div>
          <div className={"mb-1 " + style.textArea}>
            <Form.Label>
              آیا امکان تامین ضمانت مورد نیاز &#34;چک صیادی به مبلغ 500 میلیون
              تومان&#34; را دارید؟
            </Form.Label>
            <Form.Select {...register("guaranty")}>
              <option value="بله">بله </option>
              <option value="خیر">خیر</option>
            </Form.Select>
          </div>
          <div className={"mb-1 " + style.textArea}>
            <Form.Label>
              آیا توان تجهیز نمایندگی تا ۳۵ میلیون تومان را دارید؟
            </Form.Label>
            <Form.Select {...register("equipAbility")}>
              <option value="بله">بله </option>
              <option value="خیر">خیر</option>
            </Form.Select>
          </div>
          <div className={"mb-1 " + style.textArea}>
            <Form.Label>
              آیا توان پرداخت حقوق و حق بیمه کارکنان خود را دارید؟
            </Form.Label>
            <Form.Select {...register("salaryAbility")}>
              <option value="بله">بله </option>
              <option value="خیر">خیر</option>
            </Form.Select>
          </div>
          <div className={"mb-1 " + style.textArea}>
            <Form.Label>سوابق پستی دارید؟ توضیح دهید</Form.Label>
            <Form.Control as="textarea" {...register("relatedExperience")} />
          </div>
          <div className={"mb-1 " + style.textArea}>
            <Form.Label>توضیحات</Form.Label>
            <Form.Control as="textarea" {...register("description")} />
          </div>
          <div className="mb-1">
            {isloading === true ? (
              <button className="btn-success-style text-center" type="button">
                <div className="d-flex align-items-center justify-content-evenly">
                  <Spinner
                    style={{
                      width: "20px",
                      height: "20px",
                      fontSize: "0.8rem",
                    }}
                  />
                  <span className="me-1"> در حال ثبت</span>
                </div>
              </button>
            ) : (
              <button className="btn-success-style text-center" type="submit">
                ثبت
              </button>
            )}
          </div>
        </div>
      </form>

      {showModalCode === true && (
        <AgentFormModal
          close={() => setShowModalCode(() => false)}
          phone={getValues("phone")}
          nationalCode={getValues("nationalCode")}
        />
      )}
    </Fragment>
  );
}

export default AgentForm;
